import Axios from 'api/client';

type TwoFactorProvider = 'email' | 'sms';

const requestTwoFactorCode = (provider: TwoFactorProvider) =>
    Axios.post(`/two-factor-challenge/${provider}/code`).then(res => res.data);

const verifyTwoFactorCode = (provider: TwoFactorProvider, code: string) =>
    Axios.post(`/two-factor-challenge/${provider}`, { code }).then(res => res.data);

export { requestTwoFactorCode, verifyTwoFactorCode };

export type { TwoFactorProvider };
